import { Box, type BoxProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type GlassPanelElement = 'div' | 'article' | 'section' | 'header' | 'footer';

type GlassPanelProps = Omit<BoxProps, 'as'> & {
  as?: GlassPanelElement;
  children: ReactNode;
};

export function GlassPanel({ as = 'div', children, ...rest }: GlassPanelProps) {
  return (
    <Box as={as} layerStyle="glassPanel" {...rest}>
      {children}
    </Box>
  );
}